const NAME = "TURN_DEFINITION";

export default NAME;
